import svg4everybody from 'svg4everybody';
document.addEventListener("DOMContentLoaded", function() {
	svg4everybody();
	var tobii = new Tobii({
		captions: false,
		zoom: false,
		nav: false,
		counter: false,
		keyboard: false,
		draggable: false,
		closeText: `<svg width="34" height="34" viewBox="0 0 34 34" fill="#fff" xmlns="http://www.w3.org/2000/svg">
<path fill="#fff" d="M29.0282 4.9732C22.399 -1.65773 11.6092 -1.65773 4.98005 4.9732C1.76888 8.1865 0 12.4578 0 17.0005C0 21.5431 1.76888 25.8145 4.98005 29.0265C8.29528 32.3426 12.6497 34 17.0041 34C21.3584 34 25.7129 32.3426 29.0281 29.0265C35.6572 22.3956 35.6572 11.6054 29.0282 4.9732ZM27.1657 27.1636C21.5627 32.7682 12.4455 32.7682 6.84243 27.1636C4.12918 24.4496 2.63423 20.8396 2.63423 17.0005C2.63423 13.1613 4.12918 9.5514 6.84243 6.83608C12.4455 1.23148 21.5627 1.23281 27.1657 6.83608C32.7675 12.4407 32.7675 21.5603 27.1657 27.1636Z" />
<path fill="#fff" d="M22.6794 20.641L18.9506 16.9175L22.6794 13.1941C23.1931 12.6804 23.1931 11.8467 22.6808 11.3316C22.1658 10.8153 21.332 10.8166 20.8171 11.3303L17.0857 15.0564L13.3543 11.3303C12.8393 10.8166 12.0055 10.8153 11.4905 11.3316C10.9769 11.8466 10.9769 12.6803 11.4919 13.1941L15.2207 16.9175L11.4919 20.641C10.9769 21.1547 10.9769 21.9884 11.4905 22.5035C11.7474 22.7616 12.0859 22.8894 12.4231 22.8894C12.7603 22.8894 13.0975 22.7603 13.3543 22.5048L17.0857 18.7786L20.8171 22.5048C21.074 22.7616 21.4111 22.8894 21.7484 22.8894C22.0856 22.8894 22.424 22.7603 22.6809 22.5035C23.1944 21.9884 23.1944 21.1547 22.6794 20.641Z" />
</svg>
`
	});
	var lazyLoadInstance = new LazyLoad();

	const tabs = document.querySelectorAll(`.js-tabs`);

	const removeClass = (arr, className) => {
		[...arr].forEach((el) => {
			el.classList.remove(`${className}`)
		})
	}

	const setActiveTab = (tabContainer, button) => {
		const allBtns = tabContainer.querySelectorAll(`.js-tabs__button`);
		removeClass(allBtns, `js-tabs__button--active`);
		button.classList.add(`js-tabs__button--active`);
	}

	const showRelateTabBlock = (tabContainer, button) => {
		const allTabs = tabContainer.querySelectorAll(`.js-tabs__tab`);
		removeClass(allTabs, `js-tabs__tab--active`);
		const activeTab = [...allTabs].find((tab) => tab.dataset.id === `${button.dataset.pointer}`);
		activeTab.classList.add(`js-tabs__tab--active`);
	}

	const toggleTab = (tabContainer, button) => {
		setActiveTab(tabContainer, button);
		showRelateTabBlock(tabContainer, button);
	}

	const initTabs = () => {
		[...tabs].forEach((tabContainer) => {
			const tabsControls = tabContainer.querySelector(`.js-tabs__controls`)
			tabsControls.addEventListener(`click`, (evt) => {
				const self = evt.target;
				if(!self.closest(`.js-tabs__button`)) {
					return
				} else {
					toggleTab(tabContainer, self)
				}
			})
		})
	}
	initTabs();

	//popups

	const popupOpenBtns = document.querySelectorAll(`.js-popup`);

	const fillPopup = (popup, button) => {
		const popupBody = popup.querySelector(`.popup-content`);
		const parentBlock = button.closest(`.js-content-item`);
		popupBody.innerHTML = '';
		const body = parentBlock.querySelector(`.js-full`).cloneNode(true);
		popupBody.appendChild(body);
		lazyLoadInstance.update();
	}
	const closePopup = (popup) => {
		popup.classList.remove('popup--shown');
		document.body.removeAttribute('style');
	};
	const addListeners = (popup, popupCloseBtn, popupLayout) => {
		popupCloseBtn.addEventListener(`click`, () => {
			closePopup(popup)
		});
		popupLayout.addEventListener(`click`, (evt) => {
			if (evt.target === evt.target.closest(`.popup__layout`)) {
				closePopup(popup);
			}
		});
	};
	const openPopup = (popup, button) => {
		const popupCloseBtn = popup.querySelector(`.popup__close`);
		const popupLayout = popup.querySelector(`.popup__layout`);
		addListeners(popup, popupCloseBtn, popupLayout);
		popup.classList.add('popup--shown');
		document.body.style.cssText = "overflow:hidden"
		if (popup.id === 'content') {
			fillPopup(popup, button);
		}
	};

	const onPopupBtnClick = (evt) => {
		const self = evt.target;
		const pointer = self.dataset.pointer;
		openPopup(document.querySelector(`#${pointer}`), self);

	};
	[...popupOpenBtns].forEach((btn) => {
		btn.addEventListener(`click`, onPopupBtnClick);
	});


	// accordion

	const accordions = document.querySelectorAll(`.js-accordion`);

	const onAccClick = (clickedToggler) => {
		const parent = clickedToggler.closest(`.js-accordion__item`);
		const accordion = clickedToggler.closest(`.js-accordion`);
		const allItems = accordion.querySelectorAll(`.js-accordion__item`);
		if (parent.classList.contains(`js-accordion__item--open`)) {
			removeClass(allItems, `js-accordion__item--open`);
		} else {
			removeClass(allItems, `js-accordion__item--open`);
			parent.classList.add(`js-accordion__item--open`);
		}

	}

	[...accordions].forEach((acc) => {
		acc.addEventListener(`click`, (evt) => {
			if(evt.target === evt.target.closest(`.js-accordion__toggler`)) {
				onAccClick(evt.target);
			}
		});
	})

	const expandableBtn = document.querySelectorAll(`.js-expandable__button`);
	const onExpandableBtnClick = (evt) => {
		const self = evt.target;
		const parent = self.closest(`.js-expandable`);
		const content = parent.querySelector(`.js-expandable__block`);
		content.style.cssText = `max-height:none`;
		self.style.cssText = `display:none`
	}
	if (expandableBtn.length > 0) {
		[...expandableBtn].forEach((btn) => {
			btn.addEventListener(`click`, onExpandableBtnClick)
		})
	}



	const galleryThumbs = new Swiper('.article-full__pagination .swiper-container', {
		spaceBetween: 10,
		slidesPerView: 3,
		freeMode: true,
		observer: true,
		observeParents: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});

	const galleryTop = new Swiper('.article-full__carousel .swiper-container', {
		spaceBetween: 10,
		observer: true,
		observeParents: true,
		lazy: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		thumbs: {
			swiper: galleryThumbs,
		},
	});

	const сhangeText = (el, text) => {
		el.textContent = text;
	};

	const closeMultiSelect = (select) => {
		select._el.classList.remove(`select--open`);
	};

	const onEscPress = (evt, select) => {
		if (evt.key === "Escape" || evt.key === "Esc") {
			closeMultiSelect(select);
		}
	};

	const onDocumentClick = (evt, select) => {
		if (!evt.target.closest(`.select`)) {
			closeMultiSelect(select);
		}
	};

	class CustomSelect {
		constructor(select) {
			this._el = select;
			this._toggler = null;
			this._dropdown = null;
			this._dropdownItems = null;
			this._onTogglerClick = this._onTogglerClick.bind(this);
			this._onDropdownChange = this._onDropdownChange.bind(this);
			this._onChange = null;
		}

		_onDropdownChange(evt) {
			if (typeof this._onChange === `function`) {
				this._onChange(evt);
			}
		}

		set onChange(fn) {
			this._onChange = fn;
		}

		_onTogglerClick() {
			const allCustomSelects = document.querySelectorAll(`.select`);
			if (this._el.classList.contains(`select--open`)) {
				closeMultiSelect(this);
				this.unbind();
			} else {

				[...allCustomSelects].forEach((it) => {
					it.classList.remove(`select--open`);
				});
				this._el.classList.add(`select--open`);
				this.bind();
			}
		};

		unbind() {
			this._dropdown.removeEventListener(`change`, this._onDropdownChange);
			document.removeEventListener(`click`, onDocumentClick);
			document.removeEventListener(`keydown`, onEscPress);
		};

		bind() {
			this._dropdown.addEventListener(`change`, this._onDropdownChange);
			document.addEventListener(`click`, (evt) => {
				onDocumentClick(evt, this);
			});
			document.addEventListener(`keyup`, (evt) => {
				onEscPress(evt, this);
			});
		};

		init() {
			this._dropdown = this._el.querySelector(`.select__dropdown`);
			this._dropdownItems = this._dropdown.querySelectorAll(`.select__dropdown-item input`);
			this._toggler = this._el.querySelector(`.select__toggler`);
			сhangeText(this._toggler, this._el.dataset.intro);
			this._toggler.addEventListener(`click`, this._onTogglerClick);
			this._dropdownItems.forEach((item)=>{
				item.checked = false;
			})
		};
	}

	const initCustomSelects = (container) => {
		const customSelect = container.querySelectorAll(`.select`);
		[...customSelect].forEach((it) => {
			const customSelect = new CustomSelect(it);
			customSelect.init();
			customSelect.onChange = (evt) => {
				сhangeText(customSelect._toggler, evt.target.dataset.value);
				closeMultiSelect(customSelect);
				customSelect.unbind();
			}
		});
	};

	initCustomSelects(document);


	// service-carousels

	const serviceGallery = document.querySelectorAll(`.service-gallery`);

	[...serviceGallery].forEach((gallery) => {
		const galleryCarousel = gallery.querySelector(`.swiper-container`);
		const mySwiper1 = new Swiper(galleryCarousel, {
			spaceBetween: 30,
			navigation: false,
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
			slidesPerView: 3,
			breakpoints: {
				320: {
					slidesPerView: 1
				},
				370: {
					slidesPerView: 2
				},
				600: {
					slidesPerView: 3
				}
			}
		})
	});


	const heroCarousel = document.querySelector(`.hero .swiper-container`);
	const mySwiper11 = new Swiper(heroCarousel, {
		navigation: false,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
	});

	const mainDoctorsCarousel = document.querySelector(`.main-doctors .swiper-container`);
	const mySwiper111 = new Swiper(mainDoctorsCarousel, {
		lazy: true,
		spaceBetween: 35,
		slidesPerView: 4,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: false
	});

	const mainReviewsCarousel = document.querySelector(`.main-reviews .swiper-container`);
	const mySwiper1111 = new Swiper(mainReviewsCarousel, {
		spaceBetween: 35,
		slidesPerView: 2,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: false,
	});


	//map

	let myMap;
	let myPlacemark;
	const coords = [
		[61.274326,73.365897],
		[61.236782,73.436048],
		[61.264748,73.419594],
		[61.240007,73.439774],
		[61.247123,73.377881],
		[61.277859,73.376451],
		[61.236782,73.436048]
	]
	function init() {
		myMap = new ymaps.Map("map", {
			center: coords[0],
			zoom: 16,
			controls: ['smallMapDefaultSet']
		});
		const placemarkContent = {
			hintContent: 'Наджа',
		}
		const placemarkOptions =  {
			iconLayout: 'default#image',
			iconImageHref: 'assets/images/nadja-pin.svg',
			iconImageSize: [32, 73],
			iconImageOffset: [-16, -63]
		}
		coords.forEach((coord) => {
			myPlacemark = new ymaps.Placemark(coord,placemarkContent,placemarkOptions);
			myMap.geoObjects
				.add(myPlacemark)
		})
		myMap.behaviors.disable('scrollZoom');

	}

	svg4everybody();

	let yaMapsShown = false;
	const map = document.querySelector(`#map`)

	const isVisible = function (target) {
		let targetPosition = {
				top: window.pageYOffset + target.getBoundingClientRect().top,
				left: window.pageXOffset + target.getBoundingClientRect().left,
				right: window.pageXOffset + target.getBoundingClientRect().right,
				bottom: window.pageYOffset + target.getBoundingClientRect().bottom
			},
			windowPosition = {
				top: window.pageYOffset,
				left: window.pageXOffset,
				right: window.pageXOffset + document.documentElement.clientWidth,
				bottom: window.pageYOffset + document.documentElement.clientHeight
			};

		if (!yaMapsShown && targetPosition.bottom > windowPosition.top &&
			targetPosition.top < windowPosition.bottom &&
			targetPosition.right > windowPosition.left &&
			targetPosition.left < windowPosition.right) {
			yaMapsShown = true;
			ymaps.ready(init);
		}
	};

	window.addEventListener('scroll', function() {
		isVisible (map);
	});

	isVisible(map);

	//setCenter

	const mapToggleBtns = document.querySelectorAll(`.js-tabs--maps .js-tabs__button`);
	[...mapToggleBtns].forEach((btn, index) => {
		btn.addEventListener(`click`, (evt) => {
			myMap.panTo(
				coords[index], {
					flying: true,
					duration: 1000
				}
			)

		})
	})

});





// WEBPACK FOOTER //
// ./app/scripts/app.js